import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import Colors from '../constants/Colorsv2';
import { Text } from '../globalComponents/NativeOverrides'

type AppModeToggleProps = { 
    balance:number, 
    free_market_balance:number,
    promo_balance:number,
    market_type:string, 
    onAppModeChange:any, 
    onBalancePress:any
}
const AppModeToggle = ({ balance, promo_balance, free_market_balance, market_type, onAppModeChange, onBalancePress }: AppModeToggleProps) => {
    return (
        <View style={{flexDirection:'row'}}>
            {market_type == 'FOR_MONEY' ?
            <TouchableOpacity style={{marginRight:10}} onPress={() => onBalancePress()}>
                <Text textAlign='right' size={14} weight={'semibold'} color={Colors.shades.white} style={{ padding: 1 }}>${balance.toFixed(2)}</Text>
                <Text textAlign='right' size={10} weight={'semibold'} color={Colors.shades.white} style={{ padding: 1 }}>Promo {promo_balance.toFixed(2)}</Text>
            </TouchableOpacity>
            :
            <TouchableOpacity style={{marginRight:10}} onPress={() => onBalancePress()}>
                <Text textAlign='right' size={8} weight={'light'} color={Colors.shades.white} style={{ padding: 1 }}>${balance.toFixed(2)}</Text>
                <Text textAlign='right' size={14} weight={'semibold'} color={Colors.shades.white} style={{ padding: 1 }}>E{free_market_balance.toFixed(2)}</Text>
            </TouchableOpacity>
        }
            <TouchableOpacity style={{ width:15, borderRadius:100, backgroundColor:Colors.shades.white, padding:1 }} onPress={() => onAppModeChange(market_type==='FOR_MONEY'?'FREE':'FOR_MONEY')}>

                <View style={{flex:1/2, borderRadius:100, backgroundColor:market_type==='FOR_MONEY'?Colors.utility.success:'transparent'}}/>
                <View style={{flex:1/2, borderRadius:100, backgroundColor:market_type==='FREE'?Colors.utility.success:'transparent'}} />
            </TouchableOpacity>
            
        </View>
    )
}


export default AppModeToggle